import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextStyle from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import FontFamily from "@tiptap/extension-font-family";
import Bold from "@tiptap/extension-bold";
import Placeholder from "@tiptap/extension-placeholder";

import { FontSize as TextStyleExtras } from "./tiptapFontSize";
import { TextBackgroundColor } from "./tiptapBackgroundColor";

export function getEmailTiptapExtensions({ withPlaceholder = false, withLink = true } = {}) {
  const extensions = [
    StarterKit.configure({
      heading: false,
      bold: false,
    }),
    // Render bold with inline style so it can't be overridden by Kevi's global CSS.
    Bold.configure({
      HTMLAttributes: {
        style: "font-weight:700",
      },
    }),
    Underline,
    TextStyle,
    Color,
    FontFamily,
    TextStyleExtras,
    TextBackgroundColor,
  ];

  if (withLink) {
    extensions.push(
      Link.configure({
        openOnClick: false,
      }),
    );
  }

  if (withPlaceholder) {
    extensions.push(
      Placeholder.configure({
        placeholder: "Digite aqui...",
      }),
    );
  }

  return extensions;
}


